import { Component, OnDestroy, signal } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'
import { getMetricFromMap } from '../../../shared/metrics/rollouts-map-metrics'
import { getRoadCoverageMetricFromMap } from '../../../shared/metrics/road-coverage-metrics'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { MetricModel } from 'src/app/shared/models/metric.model'
import { Layers } from 'src/app/shared/layers-config/layers'
import { getSpeedProfileMetricFromMap } from 'src/app/shared/metrics/speed-profile-metrics'

@Component({
  selector: 'app-internal-legend',
  templateUrl: './internal-legend.component.html',
  standalone: false,
})
export class InternalLegendComponent implements OnDestroy {
  private cleanUp$ = new Subject<void>()
  public metrics: string | undefined
  public isRolloutMetricLayerVisible = signal(false)
  public isRoadCoverageLayerVisible = signal(false)
  public isSpeedProfileLayerVisible = signal(false)

  public rolloutMetric = signal<MetricModel | undefined>(undefined)
  public roadCoverageMetric: MetricModel | undefined = undefined
  public speedProfileMetric: MetricModel | undefined = undefined

  constructor(private appState: AppStateService) {
    this.roadCoverageMetric = getRoadCoverageMetricFromMap()
    this.speedProfileMetric = getSpeedProfileMetricFromMap()
    this.evaluateQueryParameters()

    this.appState.stateChanged.pipe(takeUntil(this.cleanUp$)).subscribe(() => {
      this.evaluateQueryParameters()
    })
  }
  ngOnDestroy(): void {
    this.cleanUp$.next()
    this.cleanUp$.complete()
  }

  evaluateQueryParameters() {
    const layers = this.appState.getState().layers
    this.isRolloutMetricLayerVisible.set(layers?.includes(Layers.RolloutsTile.name) ?? false)
    this.isRoadCoverageLayerVisible.set(layers?.includes(Layers.RoadCoverage.name) ?? false)
    this.isSpeedProfileLayerVisible.set(layers?.includes(Layers.SpeedProfile.name) ?? false)

    const rolloutsMetricKeys = this.appState.selectMetrics(Layers.RolloutsTile.name)
    if (rolloutsMetricKeys && rolloutsMetricKeys.length > 0) {
      this.rolloutMetric.set(getMetricFromMap(rolloutsMetricKeys[0]))
    }
  }
}
